export default [
    {
        name: "prediction",
        path: "/prediction",
        component: () => import("@/modules/Twitch/Prediction"),
    },
];
